export class CreateDevOpsActionRequest {
    actionName?: string;
    region?: string;
    customerId?: string;
    accountId?: string;
    environmentId?: string;
    triggerTime?: Date;
    scheduleExpression?: string;
    parameters?: any;
}